import { makeStyles } from "@material-ui/core";

export default makeStyles(() => ({
    "@global": {
        "@font-face": [
            {
                fontFamily: "VWTextCarUI",
                src: `local('VWTextCarUIRegular'), url('/fonts/VWTextCarUI-Regular.ttf') format('truetype')`,
                fontWeight: 300,
                fontStyle: "normal",
            },
            {
                fontFamily: "VWTextCarUI",
                src: `local('VWTextCarUIBold'), url('/fonts/VWTextCarUI-Bold.ttf') format('truetype')`,
                fontWeight: 500,
                fontStyle: "normal",
            },
            {
                fontFamily: "VWTextCarUI",
                src: `local('VWTextCarUILight'), url('/fonts/VWTextCarUI-Light.ttf') format('truetype')`,
                fontWeight: 200,
                fontStyle: "normal",
            },
        ],
    },
}));
